import React from "react";
import { Container, Modal } from "react-bootstrap";
import { deleteButton } from "../../services/chartService";

const ConfirmationModal = ({
  deleteParams,
  setDeleteParams,
  showConfirmationModal,
  setShowConfirmationModal,
  fetchConfigurationData,
}) => {
  const handleDeleteButton = (id, name, location, clientCurrentId, key) => {
    const deletebutton = {
      ClientId: clientCurrentId,
      LocationId: location,
      key: { [key]: id },
    };
    deleteButton(deletebutton);
    fetchConfigurationData(location !== undefined ? location : 0);
  };

  return (
    <>
      <Container>
        <Modal
          show={showConfirmationModal}
          onHide={() => setShowConfirmationModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this option? This will eliminate any
            ability for the user to filter chart list or edit charts
            specifically with this option.
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowConfirmationModal(false);
                setDeleteParams({});
              }}
            >
              No
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                setShowConfirmationModal(false);
                handleDeleteButton(
                  deleteParams.id,
                  deleteParams.config_option,
                  deleteParams.LocationId,
                  deleteParams.clientCurrentId,
                  deleteParams.type,
                );
              }}
            >
              <span> {"Yes"}</span>
            </button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default ConfirmationModal;
